module.exports = "/_next/static/images/8a8a2ef9c4ad5363e7abfaa7481655ba-anticipate.png";